import { render, staticRenderFns } from "./SessionArchives.vue?vue&type=template&id=8ab73be6"
import script from "./SessionArchives.vue?vue&type=script&lang=js"
export * from "./SessionArchives.vue?vue&type=script&lang=js"
import style0 from "./SessionArchives.vue?vue&type=style&index=0&id=8ab73be6&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports